import React from 'react';
import './styles.scss';
import { ContentSectionDetail } from '../ContentSection';
import { Group, Image, Stack, Text } from '@mantine/core';
import { getSharepointCdnFile } from '../../../utilities';
import NoImage from '../../../assets/icon/illustrations_no-document.svg';
import { FiArrowRight } from 'react-icons/fi';
import Button from '../../elements/Button';
import { useDisclosure } from '@mantine/hooks';
import ModalDetailLeaderWisdom from './ModalDetailLeaderWisdom';
import { useMutation } from '@tanstack/react-query';
import { addPoint } from '../../../services/homepage';
import { showNotification } from '../../../utilities/mantineNotification';

const LeaderWisdomItem: React.FC<ContentSectionDetail> = ({
  id,
  backgroundImageFilePath,
  shortDescription,
  imageFilePath,
  position,
  content,
  title,
  unit,
  name
}) => {
  const [opened, { open, close }] = useDisclosure(false);

  const completedMission = useMutation({
    mutationFn: addPoint,
    onSuccess: () => {
      // showNotification({
      //   type: 'success'
      // });
    },
    onError: (error) => {
      // showNotification({
      //   type: 'error',
      //   message: JSON.stringify(error)
      // });
    }
  });

  const handleAddPoint = (data) => {
    let payload = {
      idLearningPage: data,
      from: 'Leader Wisdom'
    };
    completedMission.mutate(payload);
  };
  return (
    <>
      <Group
        align="center"
        gap={24}
        style={{
          backgroundImage: `url(${getSharepointCdnFile(
            backgroundImageFilePath
          )})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat'
        }}
        className="container-leader-wisdom-section__item"
      >
        <div className="container-leader-wisdom-section__item__image-cover">
          <Image
            className="container-leader-wisdom-section__item__image"
            src={imageFilePath ? getSharepointCdnFile(imageFilePath) : NoImage}
            alt={name}
          />
        </div>

        <Stack gap={12} flex={1}>
          <Stack gap={0}>
            <Text fz={16} fw={700}>
              {name}
            </Text>
            <Text fz={14}>{position}</Text>
            <Text fz={14}>{unit}</Text>
          </Stack>

          <Text
            fz={20}
            className="container-leader-wisdom-section__item__description"
            style={{ whiteSpace: 'pre-line' }}
          >
            "{shortDescription}"
          </Text>

          <Button
            variant="transparent"
            styles={{
              backgroundColor: 'transparent',
              width: 'fit-content',
              padding: 0
            }}
            rightSection={<FiArrowRight />}
            onClick={() => {
              // handleAddPoint(id);
              open();
            }}
          >
            See Details
          </Button>
        </Stack>
      </Group>

      <ModalDetailLeaderWisdom
        isVisible={opened}
        content={content || shortDescription}
        name={name}
        unit={unit}
        photo={imageFilePath ? getSharepointCdnFile(imageFilePath) : NoImage}
        position={position}
        title={title}
        onClose={() => close()}
      />
    </>
  );
};

export default LeaderWisdomItem;
